export const GetPracticeAvatar = (practiceTreatment, practiceId) => {
    const data = practiceTreatment?.results?.filter((value) => value.id === parseInt(practiceId, 10));
    return data;
};